<template>
  <!-- Homepage d'un module -->
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <!-- Sidebar des infos modules -->
        <v-col lg="3" cols="12" order="last" order-md="first" class="order-md-first order-xl-first order-last">
          <div class="content-container">
            <ModuleProperties></ModuleProperties>
          </div>
        </v-col>
        <!-- Contenu de la page -->
        <v-col lg="9">
          <div class="content-container">
            <!-- Bouton de switch billetterie/sportif -->
            <SwitchButtonBilletterieToSportif></SwitchButtonBilletterieToSportif>
            <!-- Countdown ouverture du module -->
            <OpenDateMessage></OpenDateMessage>
            <!-- Message relatif au PPS -->
            <PPSMessage v-if="mainStore.module.accept_pps && !mainStore.billetterie_mode"></PPSMessage>
            <!-- Message d'informations supplémentaires -->
            <HomeMessage></HomeMessage>


            <ListCourses v-if="!mainStore.billetterie_mode"></ListCourses>
            <ListPacks v-if="!mainStore.billetterie_mode"></ListPacks>

            <BottomInscriptionSection v-if="!mainStore.billetterie_mode"></BottomInscriptionSection>
            <ListOptions></ListOptions>
            <ListActivites></ListActivites>
            <ListArticles></ListArticles>


          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import ModuleProperties from "@/components/Home/Module_Properties.vue";
import BottomInscriptionSection from "@/components/Home/Bottom_Inscription_Section.vue";
import ListCourses from "@/components/Home/Courses/List_Courses.vue";
import ListPacks from "@/components/Home/Packs/List_Packs.vue";
import ListOptions from "@/components/Home/Options/List_Options.vue";
import ListActivites from "@/components/Home/Activites/List_Activites.vue";
import ListArticles from "@/components/Home/Articles/List_Articles.vue";
import SwitchButtonBilletterieToSportif from "@/components/Home/Switch_Button_Billetterie_To_Sportif.vue";
import HomeMessage from "@/components/Home/Home_Message.vue";
import OpenDateMessage from "@/components/Home/Open_Date_Message.vue";
import PPSMessage from "@/components/Home/PPS_Message.vue";

export default {
  data() {
    return {
    };
  },
  components: { ModuleProperties, BottomInscriptionSection, ListCourses, ListPacks, ListOptions, ListActivites, ListArticles, SwitchButtonBilletterieToSportif, HomeMessage, OpenDateMessage, PPSMessage },
  computed: {
    ...mapStores(useMainStore, useBookingStore),

  },
  methods: {
    async check_lien_groupe() {
      const token_groupe = this.$route.query.groupe;
      if (token_groupe) {
        await this.mainStore.bookingSystem.groupe.fetchGroupeInfos(token_groupe, this.mainStore.module.id);
      }
    },
  },
  async mounted() {
    await this.mainStore.init_view_as_admin(this.$route.query.admin_token);
    await this.mainStore.init_inscription_as_admin(this.$route.query.admin_ins);
    this.mainStore.dossard_bourse_mode = false;
    this.bookingStore.clearState();
    await this.check_lien_groupe();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/Home.scss";
</style>
